import React from 'react'
import BbpsService from '../../myapp/services/bbps2/BbpsService'

function BBPSPage2() {
  return (
    <BbpsService/>
  )
}

export default BBPSPage2